import axios from 'axios';

export const DocumentosPut = async (url, fileData) => {
    const response = await axios.put(url, fileData, {
        headers: {
            'Content-Type': 'application/octet-stream',
        }
    });
};